module.exports = __webpack_public_path__ + "static/img/order-pc-4.23edea9c.png";